//
import { DateTime } from 'luxon';

export const getStatusText = (share, prefix = null) => {
  let status;
  switch (share.state) {
    case 'INVITED':
      status = share.expired ? 'Expired' : 'Invited';
      break;
    case 'ACTIVE':
      if (share.lastAccessedAt) {
        const lastAccessedAt = DateTime.fromISO(share.lastAccessedAt);
        const diff = DateTime.now().diff(lastAccessedAt, ['months', 'days', 'hours', 'minutes', 'seconds']);
        if (diff.days) {
          status = `${diff.days} day${diff.days > 1 ? 's' : ''} ago`;
        } else if (diff.hours) {
          status = `${diff.hours} hour${diff.hours > 1 ? 's' : ''} ago`;
        } else if (diff.minutes) {
          status = `${diff.minutes} minute${diff.minutes > 1 ? 's' : ''} ago`;
        } else {
          const seconds = Math.round(diff.seconds);
          status = `${seconds} ${seconds !== 1 ? 's' : ''} ago`;
        }
        if (prefix) {
          status = `${prefix} ${status}`;
        }
      }
      break;
    case 'INACTIVE':
      status = 'Revoked';
      break;
    case 'ABANDONED':
      status = 'Left';
      break;
    default:
  }
  return status;
};

export const getNameData = (firstName, lastName, email) => {
  if (firstName && lastName) {
    return {
      initials: firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase(),
      name: `${firstName} ${lastName}`,
    };
  }
  if (firstName) {
    return {
      initials: firstName.charAt(0).toUpperCase(),
      name: firstName,
    };
  }
  if (lastName) {
    return {
      initials: lastName.charAt(0).toUpperCase(),
      name: lastName,
    };
  }
  if (email) {
    return {
      initials: email.substring(0, 1).toUpperCase(),
      name: email.substring(0, email.lastIndexOf('@')),
    };
  }
  return null;
};
